import { api } from './oauth-api-service'
import { agentBaseUrl } from 'helpers/effects'

// @ts-ignore
const AGENT_BASE_URL = agentBaseUrl

export default api(AGENT_BASE_URL);
